import { ModelBase } from 'store/model-base';

export class StatementPdf extends ModelBase {
    public static storeName: string = 'statementPdf';
    public message: string;
    public pdf_url: string;
}
